import { ArrowUpRight } from "lucide-react";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <p className="font-display font-900 tracking-tighter text-4xl sm:text-6xl text-[#F8F7FA]/10 select-none leading-none mb-14">
        SHIP WITH EASE
      </p>

      <div className="grid sm:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/bec-logo.jpg"
              alt="BEC Couriers logo"
              className="w-9 h-9 rounded-full object-cover ring-1 ring-white/20"
            />
            <span className="font-display font-800 text-lg">
              BEC <span className="text-[#FF8A00]">Couriers</span>
            </span>
          </div>
          <p className="text-sm text-[#A29DB0] leading-relaxed max-w-xs">
            Shop #16 South Parade Plaza, Linstead, St Catherine, Jamaica
            <br />
            Mon – Sat · 9:00am – 5:30pm
            <br />
            Delivering in and around Spanish Town, St Catherine
          </p>
        </div>

        <div>
          <p className="font-mono-accent text-xs tracking-widest uppercase text-[#A29DB0] mb-4">
            Explore
          </p>
          <div className="flex flex-col gap-2.5">
            {["services", "how-it-works", "rates", "contact"].map((id) => (
              <button
                key={id}
                data-testid={`footer-nav-${id}`}
                onClick={() => scrollTo(id)}
                className="text-left text-sm text-[#A29DB0] hover:text-white transition-colors duration-200 capitalize"
              >
                {id.replace("-", " ")}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono-accent text-xs tracking-widest uppercase text-[#A29DB0] mb-4">
            Your account
          </p>
          <div className="flex flex-col gap-3">
            <a
              data-testid="footer-register-link"
              href="https://becc.takumiwhm.com/auth/register?tenantHost=becc.takumiwhm.com&returnUrl=https%3A%2F%2Fbecc.takumiwhm.com"
              target="_blank"
              rel="noreferrer"
              className="group inline-flex w-fit px-5 py-2.5 rounded-full bg-[#FF8A00] text-[#12071F] text-sm font-semibold hover:bg-[#FF9F2E] transition-colors duration-200 items-center gap-1.5"
            >
              Create a free mailbox — new accounts
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              data-testid="footer-login-link"
              href="https://bec.tasoko.com/login"
              target="_blank"
              rel="noreferrer"
              className="group text-sm text-[#A29DB0] hover:text-white transition-colors duration-200 flex items-center gap-1.5"
            >
              Login — current customers (old system)
              <ArrowUpRight className="w-3.5 h-3.5 text-[#FF8A00] transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:clearlybec@gmail.com"
              className="text-sm text-[#A29DB0] hover:text-white transition-colors duration-200"
            >
              clearlybec@gmail.com
            </a>
            <a
              data-testid="footer-phone-link"
              href="tel:+18763555819"
              className="text-sm text-[#A29DB0] hover:text-white transition-colors duration-200"
            >
              (876) 355-5819
            </a>
            <a
              data-testid="footer-landline-link"
              href="tel:+18769033276"
              className="text-sm text-[#A29DB0] hover:text-white transition-colors duration-200"
            >
              (876) 903-3276 · Landline
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono-accent text-xs text-[#A29DB0]">
          © 2026 BEC Couriers · Linstead, Jamaica
        </p>
        <p className="font-mono-accent text-xs text-[#A29DB0]">
          Air &amp; Ocean Freight · Customs Clearance
        </p>
      </div>
    </div>
  </footer>
);
